import React, { useEffect, useState } from 'react';
import Utils from 'files/Utils.js';

const GlobalBanner = ({ children, color, icon, style }) => {
    
    const [backgroundColor, setBackgroundColor] = useState('rgba(0,0,0,0)');

    useEffect(() => {
        setBackgroundColor(Utils.hexToRGBA(color, 0.75));
    }, [color]);

    return (
        <div style={{
            alignItems: 'center',
            backgroundColor: backgroundColor,
            backdropFilter: 'blur(10px)',
            borderColor: color,
            borderRadius: 12,
            borderStyle: 'solid',
            borderWidth: 2,
            display: 'inline-flex',
            flexDirection: 'row',
            justifyContent: 'center',
            marginTop: 8,
            maxWidth: '100%',
            padding: '16px 20px 16px 20px',
            pointerEvents: 'auto',
            textAlign: 'center',
            WebkitBackdropFilter: 'blur(10px)',
            ...style
        }}>
            {icon && (
                <img
                className={'d-none d-xl-flex'} 
                src={icon}
                style={{ 
                    height: 25,
                    marginRight: 8,
                    width: 25 
                }} />
            )}
            {children}
        </div>
    )
}

export default GlobalBanner;